import { Grid } from '@mui/material';
import { Fragment, useState } from 'react';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import CasteCreateView from '../../../components/front_office/caste/CasteCreateView';
import CasteListView from '../../../components/front_office/caste/CasteListView';

const FrontCasteCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.FrontOfficeURL + 'front/caste/create/list/view/');

    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };

  return (
      <Fragment>
          <Grid container spacing={3}>
              <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                  <CasteCreateView handleFormSuccess={handleFormSuccess} />
              </Grid>
              <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                  <CasteListView handleFormSuccess={handleFormSuccess} setOnURL={setOnURL} data={data} error={error} loading={loading} />
              </Grid>
          </Grid>
      </Fragment>
  )
}

export default FrontCasteCreateListView